<template>
  <div>
    <v-layout wrap>
      <v-text-field pa-1 ref="nameInput" label="CoFactor" :value="value.AnalyteName" :rules="formRuleAnalyteName" @input="emitUpdate('AnalyteName', $event)"></v-text-field>
      <v-text-field pa-1 ref="valueInput" label="Value" :value="value.Value" :rules="formRuleValue" @input="emitUpdate('Value', $event)"></v-text-field>
      <v-text-field pa-1 ref="unitsInput" label="Units" :value="value.Units" :rules="formRuleUnits" @input="emitUpdate('Units', $event)"></v-text-field>
    </v-layout>
  </div>
</template>
<script>
  import FormValidationUtil from '@/components/mixins/FormValidationUtil'
  export default {
    mixins: [FormValidationUtil],
    props: {
      value: {
        type: Object,
        required: true,
      },
      row: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        formRuleAnalyteName: [
          v => this.rules.required(v) || 'Analyte Name is required',
        ],
        formRuleUnits: [v => this.rules.required(v) || 'Unit is required'],
        formRuleValue: [
          v => this.rules.numeric(v) || 'Value must be a number',
        ],
      }
    },
    methods: {
      emitUpdate(key, value) {
        let data = JSON.parse(JSON.stringify(this.value))
        data[key] = value
        this.$emit('input', data)
      },
    },
  }
</script>